// Module
var code = `<div class="modal-dialog modal-lg" role="document" id="mapIndexSyntaxDialog">
    <div class="modal-content">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-cancel"></i></button>
            <h3 class="margin-bottom margin-top">The Index Map Function</h3>
            <div class="margin-bottom">
                The Map function projects the fields to search on or to group by for the Reduce function.<br>
                When using Multi-Maps, each Map function should project the <strong>same</strong> set of fields.
            </div>
            <hr>
            <div class="margin-bottom">
                The following examples index data for companies located in USA.
            </div>
            <div class="row">
                <div data-bind="foreach: \$data.constructor.samples">
                    <div class="col-md-6">
                        <div class="margin-top">
                            <h3>
                                <strong data-bind="text: title"></strong>Map Example
                            </h3>
                        </div>
                        <pre class="copy-area"><a href="#" class="copy-button-hidden" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, title)"><i class="icon-copy"></i></a><span data-bind="html: html"></span></pre>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;